import React from "react";
import {
  Dialog,
  DialogContent,
  MenuList,
  MenuItem,
  ListItemText
} from "@material-ui/core";
import { professions as profs } from "@bonliva-crm/common";

type Props = {
  open: boolean;
  onClose: () => void;
  professions: string[];
  onSelect: (profession: string) => void;
};

export function ProfessionSelectorDialog(props: Props) {
  const { professions } = props;
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogContent style={{ padding: 0 }}>
        <MenuList>
          {professions.map((item) => {
            return (
              <MenuItem
                key={item}
                onClick={() => props.onSelect(item)}
                style={{
                  height: "initial"
                }}
              >
                <ListItemText primary={profs.getProfessionDisplayName(item)} />
              </MenuItem>
            );
          })}
        </MenuList>
      </DialogContent>
    </Dialog>
  );
}
